var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThrdCardImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#32CCCC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6302 15.3368C16.7577 15.3368 17.6718 16.2509 17.6718 17.3785V28.462C17.6718 29.5896 16.7577 30.5037 15.6302 30.5037H10.375C9.2474 30.5037 8.33331 29.5896 8.33331 28.462V17.3785C8.33331 16.2509 9.2474 15.3368 10.375 15.3368H15.6302ZM13.2942 26.4147H12.7109C12.2277 26.4147 11.8359 26.8064 11.8359 27.2897C11.8359 27.7729 12.2277 28.1647 12.7109 28.1647H13.2942C13.7775 28.1647 14.1692 27.7729 14.1692 27.2897C14.1692 26.8064 13.7775 26.4147 13.2942 26.4147ZM30.7909 25.2498C31.2742 25.2498 31.6659 25.6416 31.6659 26.1248C31.6659 26.5678 31.3367 26.9339 30.9096 26.9918L30.7909 26.9998L18.8329 26.9992V25.2492L30.7909 25.2498ZM27.2916 11.8337C28.4192 11.8337 29.3333 12.7478 29.3333 13.8754V22.6257C29.3333 23.7533 28.4192 24.6674 27.2916 24.6674L18.8329 24.6671L18.8333 16.5C18.8333 15.2699 17.8815 14.2621 16.6741 14.1731L16.5 14.1667L10.6662 14.1659L10.6666 13.8754C10.6666 12.7478 11.5807 11.8337 12.7083 11.8337H27.2916Z",
    fill: "#32CCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrdCardImage);
export default __webpack_public_path__ + "static/media/thrd-card-image.4c0cc8711dc769006148ea2fe23d12d6.svg";
export { ForwardRef as ReactComponent };